import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/TermsOfService/termsOfService__en-GB.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-GB'].layout },
  seo: {
    ...sharedConfig['en-GB'].seo,
    title: 'Lemonade UK: Terms of Service',
    metaTitle: 'Lemonade UK: Terms of Service',
    description:
      'Review Lemonade UK’s Terms of Service to understand your rights, obligations, and the conditions of using our Home insurance platform.',
  },
  MDXContent: content as DocumentTypes,
};
